import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Button, ButtonGroup, Backdrop, Card, CardContent, ListItemAvatar, Chip, ListItemText, ListItem, List, Avatar, Divider, Grid, IconButton, Select, Snackbar, TextField, Typography, CircularProgress, Modal } from "@mui/material";
import { useState, useContext } from "react";
import { ColorModeContext, useMode } from "../theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Topbar } from '../layouts/Topbar'; 
import AuthContext from "../auth/AuthProvider";
import Sidebarr from '../layouts/Sidebar';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Header from "../components/Header";
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PropTypes from 'prop-types';
import { decode } from "base-64";
import Autocomplete from '@mui/material/Autocomplete';
import { api } from '../api';
import { fetchToken, fetchRole } from '../auth/Token';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useFormik, validateYupSchema } from 'formik';
import * as Yup from 'yup';
import {Stepper, Step, StepLabel, FormHelperText, MenuItem} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { ConnectingAirportsOutlined } from '@mui/icons-material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import SummarizeIcon from '@mui/icons-material/Summarize';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import KPeeLogo from '../LogoKPee1.png';

const FormatedDate = ({value}) => {
    const timestamp = value;
    const date = new Date(timestamp);
  
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours() % 12 || 12).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const amOrPm = date.getHours() >= 12 ? 'PM' : 'AM';
  
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes} ${amOrPm}`;
    return <span>{formattedDate}</span>;
}
  


const PrintScreen = () => {
    const [theme, colorMode] = useMode();
    const [isSidebar, setIsSidebar] = useState(true);
    const location = useLocation();
    const one = location.state && location.state.one;
    const association_data = location.state && location.state.association_data;
    const association_id = location.state && location.state.association_id;
    const {  permissions } = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [ope, setOpe] = React.useState(false);
    const [backdrop_open, setBackdrop_open] = useState(false)
    const [message, setMessage] = useState("");
    const [leaders, setLeaders] = useState([])

    const fetchLeaders = () => {
        api.get(`/association/get/association/leaders/${association_id}`, {
          headers: {
              Authorization: 'Bearer '+fetchToken()
          },
        }).then(function (response){
          setLeaders(response.data)
        }).catch(function (error){
          console.log(error)
        });
    }

    useEffect(() => {
        fetchLeaders();
    },[])

  

    const handleBackdropClose = () => {
        setBackdrop_open(false);
    };
    const handleBackdropOpen = () => {
        setBackdrop_open(true);
    };

    const currencyFormat = new Intl.NumberFormat('en-GH', {
        style: 'currency',
        currency: 'GHS',
    });

    const pic = (pic) => {
        const de = decode(pic);
        return `data:image/jpeg;base64,${btoa(de)}`;
    };

const printRef = React.useRef();

const handlePrint = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL('image/png');
  
    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
  
    
    const marginLeft = 25;
    const marginTop = 25;
    const marginRight = 25;
    const marginBottom = 25; 
  
    pdf.addImage(
      data,
      'PNG',
      marginLeft,
      marginTop,
      pdfWidth - marginLeft - marginRight,
      pdfHeight - marginTop - marginBottom
    );
  
    pdf.save('GroupLoan.pdf');
}
      
    
  return (
      <div className="app">
        <main className="content">
            <Box sx={{m:5}}>
                <Box sx={{ display:'flex', m:1 }}>
                        <Typography sx={{ ml:'5px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Print:</b>
                            <IconButton onClick={handlePrint}><SummarizeIcon size='small'/></IconButton>
                        </Typography>
                    </Box>
                    <div ref={printRef} style={{ display:'block', marginBottom:5 }}>
                        <Box sx={{ m:1 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={12}>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center', color:'grey',mb:3 }}><b>~ The Cooperative ~</b></Typography>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Avatar src={KPeeLogo} alt='KPee logo' sx={{ width:120, height:120, m:'auto' }} />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Typography variant='h3' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center' }}><b>{one?.group_name}</b></Typography>
                                </Grid>
                                <Grid item xs={12} md={6} sx={{ display:'block', ml:5 }}>
                                    <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Society: {association_data?.Society}</b></Typography>
                                    <Divider  variant='middle'/>
                                    <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Cluster: {association_data?.Cluster}</b></Typography>
                                    <Divider variant='middle' />
                                    <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Community: {association_data?.community_name}</b></Typography>
                                    <Divider variant='middle' />
                                    <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Savings Group: {association_data?.Association_name}</b></Typography>
                                    <Divider variant='middle' />
                                    <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Date created: {<FormatedDate value={one?.date_created}/>}</b></Typography>
                                    <Divider variant='middle' />
                                    <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Season: {one?.season}</b></Typography>
                                    <Divider variant='middle' />
                                    <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Service cost: {currencyFormat.format(one?.total_services)}</b></Typography>
                                    <Divider variant='middle' />
                                    <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Input cost: {currencyFormat.format(one?.total_inputs)}</b></Typography>
                                    <Divider variant='middle' />
                                    <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Total group cost: {currencyFormat.format(one?.group_total_cost)}</b></Typography>
                                    <Divider variant='middle' />
                                </Grid>
                                
                                <Grid item xs={12} md={12}>
                                    <Typography variant='h4' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center' }}><b>Loans</b></Typography>
                                </Grid>

                                <Grid item xs={12} md={12}>
                                    <List sx={{ mb:7 }}>
                                        {
                                            one?.member_loans.map((member) => (
                                            <>
                                                <ListItem
                                                    alignItems="flex-start"
                                                    secondaryAction={
                                                        <Typography sx={{ mb:40 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Total cost: {currencyFormat.format(member.total_cost)}</b>
                                                        </Typography>
                                                    }
                                                >
                                                <ListItemAvatar>
                                                    <Avatar sx={{ width: 55, height: 55, mr:1 }} alt={member.member_name} src={pic(member.member_image)} />
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={member.member_name}
                                                    secondary={
                                                    <Box sx={{ display:'block' }}>
                                                        <div>
                                                        <Typography
                                                            sx={{ display: 'inline' }}
                                                            component="span"
                                                            variant="body2"
                                                            color="text.primary"
                                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                        >
                                                            <b>Service cost: {currencyFormat.format(member.services_cost)}</b>
                                                        </Typography>
                                                        </div>
                                                        <div>
                                                        <Typography
                                                            sx={{ display: 'inline' }}
                                                            component="span"
                                                            variant="body2"
                                                            color="text.primary"
                                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                        >
                                                            <b>Input cost: {currencyFormat.format(member.inputs_cost)}</b>
                                                        </Typography>
                                                        </div>
                                                        <div>
                                                            <Typography
                                                                sx={{ display: 'inline' }}
                                                                component="span"
                                                                variant="body2"
                                                                color="text.primary"
                                                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                            >
                                                                <b>Phone contact: {member.member_phone}</b>
                                                            </Typography>
                                                        </div>
                                                        <div>
                                                            <Typography
                                                                sx={{ display: 'inline' }}
                                                                component="span"
                                                                variant="body2"
                                                                color="text.primary"
                                                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                            >
                                                                <b>Acres planting: {member.acres}</b>
                                                            </Typography>
                                                        </div>

                                                        <div style={{ width:'100%' }}>
                                                            <Grid container spacing={2}>
                                                                {/* Inputs */}
                                                                <Grid item xs={12} md={12}>
                                                                <Typography variant='h5' sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Inputs</b></Typography>
                                                                    <Table size="small" aria-label="a dense table">
                                                                        <TableHead>
                                                                            <TableRow>
                                                                            <TableCell><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Input</b></Typography></TableCell>
                                                                            <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Company</b></Typography></TableCell>
                                                                            <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Quantity (kilos/g/liters/bags/...)</b></Typography></TableCell>
                                                                            <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Cost</b></Typography></TableCell>
                                                                            <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Price per acre</b></Typography></TableCell>
                                                                            <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Private Interest?</b></Typography></TableCell>
                                                                            <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Interest Type</b></Typography></TableCell>
                                                                            <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Interest</b></Typography></TableCell>
                                                                            <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Period(months)</b></Typography></TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {member?.inputs.map((row) => (
                                                                            <TableRow
                                                                                key={row.id}
                                                                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor:'#f5f3f4' }}
                                                                            >
                                                                                <TableCell component="th" scope="row">
                                                                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.input}</b></Typography>
                                                                                </TableCell>
                                                                                <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.company}</b></Typography></TableCell>
                                                                                <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.total_quantity}</b></Typography></TableCell>
                                                                                <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(row.cost)}</b></Typography></TableCell>
                                                                                <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(row.input_price_per_acre)}</b></Typography></TableCell>
                                                                                <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.personal_interest?'Yes':'No'}</b></Typography></TableCell>
                                                                                <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.interest_type === 'flat_rate'? 'Fixed Amount': 'Percentage amount'}</b></Typography></TableCell>
                                                                                <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.personal_interest? row.interest_type === 'flat_rate'? currencyFormat.format(row.personal_interest) :`${row.personal_interest}%` : `${row.interest_percentage_rate_anum}%`}</b></Typography></TableCell>
                                                                                <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.months? row.months: 6}</b></Typography></TableCell>
                                                                            </TableRow>
                                                                            ))}
                                                                        </TableBody>
                                                                    </Table>

                                                                </Grid>
                                                                {/* Services */}
                                                                <Grid item xs={12} md={12}>
                                                                <Typography variant='h5' sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Services</b></Typography>
                                                                    <Table size="small" aria-label="a dense table">
                                                                        <TableHead>
                                                                            <TableRow>
                                                                            <TableCell><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Service</b></Typography></TableCell>
                                                                            <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Cost</b></Typography></TableCell>
                                                                            <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Price per acre</b></Typography></TableCell>
                                                                            <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Private Interest?</b></Typography></TableCell>
                                                                            <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Interest Type</b></Typography></TableCell>
                                                                            <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Interest</b></Typography></TableCell>
                                                                            <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Period(months)</b></Typography></TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {member?.services.map((row) => (
                                                                            <TableRow
                                                                                key={row.id}
                                                                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor:'#f5f3f4' }}
                                                                            >
                                                                                <TableCell component="th" scope="row">
                                                                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.service}</b></Typography>
                                                                                </TableCell>
                                                                                <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(row.cost)}</b></Typography></TableCell>
                                                                                <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(row.service_price_per_acre)}</b></Typography></TableCell>
                                                                                <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.personal_interest?'Yes':'No'}</b></Typography></TableCell>
                                                                                <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.interest_type === 'flat_rate'? 'Fixed Amount': 'Percentage amount'}</b></Typography></TableCell>
                                                                                <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.personal_interest? row.interest_type === 'flat_rate'? currencyFormat.format(row.personal_interest) :`${row.personal_interest}%` : `${row.interest_percentage_rate_anum}%`}</b></Typography></TableCell>
                                                                                <TableCell align="right"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.months? row.months: 6}</b></Typography></TableCell>
                                                                            </TableRow>
                                                                            ))}
                                                                        </TableBody>
                                                                    </Table>

                                                                </Grid>
                                                            </Grid>
                                                        </div>
                                                    </Box>
                                                    }
                                                >

                                                </ListItemText>
                                                </ListItem>
                                                <Divider variant='middle'/>
                                            </>
                                            ))
                                        }
                                        </List>
                                </Grid>
                                
                                {
                                    leaders.map((leader) => (
                                        <Grid item xs={12} md={4}>
                                            <Divider sx={{ m:2, mt:5 }} />
                                            <Box>
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{leader?.position} ({leader?.name})</b></Typography>
                                            </Box>
                                        </Grid>
                                    ))
                                }
                                <Grid item xs={12} md={4}>
                                    <Divider sx={{ m:2, mt:5 }}/>
                                    <Box>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Sign</b></Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={4} sx={{ mb:20, mt:5 }}>
                                    <Divider />
                                    <Box>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Sign</b></Typography>
                                    </Box>
                                </Grid>
                            </Grid>

                        </Box>
                    </div>
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={backdrop_open}
                        onClick={handleBackdropClose}
                    >
                        <CircularProgress color="secondary" />
                    </Backdrop>
            </Box>
            
        </main>
      </div>
  )
}

export default PrintScreen